// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { createContext, useContext } from 'react';

export type Theme = 'light' | 'dark' | 'system';

export type ThemeStyle =
  | 'glass'
  | 'paper'
  | 'midnight'
  | 'midnight-contrast'
  | 'ocean'
  | 'forest'
  | 'morandi';

export const THEME_STYLES: ThemeStyle[] = [
  'glass',
  'paper',
  'midnight',
  'midnight-contrast',
  'ocean',
  'forest',
  'morandi',
];
export const DEFAULT_THEME_STYLE: ThemeStyle = 'glass';

export const THEME_STYLE_LABELS: Record<ThemeStyle, string> = {
  glass: '液态玻璃',
  paper: '暖纸',
  midnight: '青夜',
  'midnight-contrast': '青夜·高对比',
  ocean: '碧海',
  forest: '森息',
  morandi: '莫兰迪',
};

export type TextureMode = 'on' | 'off';
export type FontMode = 'sans' | 'serif';

export type ThemeContextValue = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'light' | 'dark';
  toggleTheme: () => void;
  isDark: boolean;
  themeStyle: ThemeStyle;
  setThemeStyle: (style: ThemeStyle) => void;
  textureMode: TextureMode;
  setTextureMode: (mode: TextureMode) => void;
  fontMode: FontMode;
  setFontMode: (mode: FontMode) => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useThemeContext() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
